import * as signalR from '@microsoft/signalr';
import { HttpTransportType } from '@microsoft/signalr';
import { WebsocketEvent } from '../constants/WebsocketEvent';

export class Connection {
  url: string;
  token: string;
  plantId: number | null;
  scope: string | number;
  events: string[];
  connection: any;

  constructor({ url, token, plantId, events, scope }: {
    url: string;
    token: string;
    plantId: number | null;
    events?: string[],
    scope: string | number,
  }) {
    this.url = url ? `https://${url}/notificationHub` : '';
    this.token = token;
    this.plantId = plantId;
    this.scope = scope;
    this.events = events || Object.values(WebsocketEvent);
    this.init();
  }

  init() {
    const url = `${this.url}/?event=${this.events.join('&event=')}&plantId=${this.plantId}&scope=${this.scope}&token=${this.token}`;

    this.connection = new signalR.HubConnectionBuilder()
      .withUrl(url, HttpTransportType.WebSockets)
      .build();
  }

  start() {
    return this.connection.start();
  }

  stop() {
    return this.connection.stop();
  }

  on(event: string, cb: (plantId: number, data: any) => void) {
    this.connection.on(event, cb);
  }

  off(event: string) {
    return this.connection.off(event);
  }

  onclose(cb: (e: any) => void) {
    return this.connection.onclose(cb);
  }

  invoke(
    event: string,
    plantId: number | null = this.plantId,
    loadStartTime: string,
    data: any,
    config: any,
  ) {
    return this.connection.invoke(event, plantId, loadStartTime, data, config);
  }
}
